module.exports = __webpack_public_path__ + "img/linkedinLogo.f2a5a6b1.svg";